var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-5"},[_c('div',{staticClass:"row mt-5"},[_c('h1',{staticClass:"display-4"},[_vm._v(_vm._s(_vm.$t('logout.success')))]),_c('p',{staticClass:"lead"},[_vm._v(_vm._s(_vm.$t('logout.message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }